export default __webpack_public_path__ + "static/media/6.b45f3edd.png";